import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {removeNullFields, getValueFromDDL} from "../../common/mapper";
import MasterParameterDetail from "./masterParameterDetail";
import MasterParameterFilter from "./masterParameterFilter";
import {fetchDataAsync} from "../../../Services/Utils";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class MasterParameter extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "bizparCategory",
            label: "Kategori Parameter",
        },
        {
            name: "bizparCategory",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (
                        <Button className="btnAct" onClick={() => this.handleDetailVisibility(val)}>
                            <i
                                className="fa fa-lw fa-pencil-alt"
                                style={{
                                    backgroundColor: "transparent",
                                    color: "red",
                                    fontSize: 20,
                                }}
                            />
                        </Button>
                    );
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            selectedData: null,
            submittedFilterData: {},
            filterData: {},
            bizparCategory: "",
            loading: false,
            filterVisible: false,
            detailVisible: false,
            isFetch: false,
            pagination: {
                totalData: 1,
                limit: 5,
                page: 1,
            },
            dataTable: [],
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevValue) => ({
            ...prevValue,
            isFetch: true,
            pagination: {...prevValue.pagination, totalData: 0},
        }));
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getBizparCategoryByParam,
            {...filter, page, limit,}
        )
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data.map(cat => {
                    return {bizparCategory: cat}
                }),
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.totalData,
                    page,
                    limit,
                },
            }));
        }
        this.setState((prevValue) => ({...prevValue, isFetch: false}));
    };

    handleDetailVisibility = async (category) => {
        this.handleTriggerLoading();
        if (category) {
            const response = await this.callApi(
                Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                {
                    paramFilters: {
                        bizparCategory: category,
                        status: Status.ACTIVE,
                    },
                });

            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        category: category,
                        data: response.data.data.map((category) => ({
                            ...category,
                            saved: true,
                        })),
                    },
                    detailVisible: !prevValue.detailVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                detailVisible: !prevValue.detailVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleClearFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {},
        }));
    };

    handleSubmitFilter = async (e) => {
        e.preventDefault();
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            bizparCategory: "",
        }));
        const filter = removeNullFields({
            ...this.state.filterData,
            status: getValueFromDDL(this.state.filterData, "status"),
        });
        await this.fetchData(filter,1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            filterVisible: false,
            submittedFilterData: filter,
        }));
    };

    handleDeleteAll = async (category) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").deleteAllBizparByCategory,
            category,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            detailVisible: !prevValue.detailVisible,
        }));
    }

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleSubmitDetail = async (data) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const requestBody = data.map((category) => ({
            bizparCategory: category.bizparCategory,
            key: category.key,
            value: category.value,
            systemId: category.systemId.value,
        }));
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").saveAllBizpar,
            requestBody,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleResetAllFilters();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            detailVisible: !prevValue.detailVisible,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleKategoriParameterChange = (name, value) => {
        this.setState((prevValue) => ({...prevValue, [name]: value}));
    };

    handleSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            filterData: {},
        }));
        const filter = removeNullFields({
            kategoriParemeter: this.state.bizparCategory,
        });
        await this.fetchData(filter, 1,this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            submittedFilterData: filter,
        }));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Parameter",
            setError: this.props.setError,
            args: args,
        })
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: {},
            bizparCategory: null,
            submittedFilterData: {},
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleInput
                                id="input_text_kategori_parameter"
                                placeholder="Kategori Parameter"
                                name="bizparCategory"
                                containerclassname="margin-bottom-5px"
                                value={this.state.bizparCategory}
                                onChange={({target}) =>
                                    this.handleKategoriParameterChange(target.name, target.value)
                                }
                            />
                            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                        </FlexView>
                        <Button
                            type="button"
                            className="btn background-red"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.totalData}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    />
                </Container>
                {this.state.filterVisible && (
                    <MasterParameterFilter
                        state={this.state}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleFilterVisibility}
                        onClearFilter={this.handleClearFilter}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.detailVisible && (
                    <MasterParameterDetail
                        state={this.state}
                        onClickClose={this.handleDetailVisibility}
                        onSubmit={this.handleSubmitDetail}
                        onDeleteAll={this.handleDeleteAll}
                    />
                )}

                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterParameter);
